import { Primitive } from '../../../types/blocks/Primitive';

const GroupRoleBlock: Primitive = {
  name: 'GroupRoleBlock',
  friendlyName: 'Team',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Other'],
  properties: {
    groupRole: {
      type: 'GroupRole',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default GroupRoleBlock;
